import * as tslib_1 from "tslib";
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { ConfigService } from './../config/config.service';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
import * as i2 from "../config/config.service";
export class ReembolsoService {
    constructor(httpClient, config) {
        this.httpClient = httpClient;
        this.config = config;
        this.headers = new HttpHeaders({
            Accept: 'application/json',
            'Content-Type': 'application/json; charset=utf-8'
        });
    }
    // Reembolso
    getBoletaDuplicada(boleta) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const config = yield this.config.getConfig();
            try {
                return yield this.httpClient.post(`${config['endpoint']}/Reembolso/EsBoletaDuplicada`, boleta, { headers: this.headers }).toPromise();
            }
            catch (error) {
                return { status: false, code: 804, message: 'Error al ejecutar la petición.' };
            }
        });
    }
    getDatosCotizante() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            this.rut = localStorage.getItem('cbRutCliente');
            const config = yield this.config.getConfig();
            try {
                return yield this.httpClient.get(`${config['endpoint']}/Reembolso/ObtenerDatosCotizante?rut=${this.rut}`, { headers: this.headers }).toPromise();
            }
            catch (error) {
                return { status: false, code: 804, message: 'Error al ejecutar la petición.' };
            }
        });
    }
    postSolicitudReembolso(iReembolso) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const config = yield this.config.getConfig();
            try {
                return yield this.httpClient.post(`${config['endpoint']}/Reembolso/InsertarSolicitudReembolso`, iReembolso, { headers: this.headers }).toPromise();
            }
            catch (error) {
                return { status: false, code: 804, message: 'Error al ejecutar la petición.' };
            }
        });
    }
    getHistorialReembolsos(iReembolso) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const config = yield this.config.getConfig();
            try {
                return yield this.httpClient.post(`${config['endpoint']}/Reembolso​/TraeHistorialReembolsos`, iReembolso, { headers: this.headers }).toPromise();
            }
            catch (error) {
                return { status: false, code: 804, message: 'Error al ejecutar la petición.' };
            }
        });
    }
    getEspecialidadMedica() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const config = yield this.config.getConfig();
            try {
                return yield this.httpClient.get(`${config['endpoint']}/Reembolso/ConsultaEspMedicas`, { headers: this.headers }).toPromise();
            }
            catch (error) {
                return { status: false, code: 804, message: 'Error al ejecutar la petición.' };
            }
        });
    }
    getReembolsoFull(iReembolso) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const config = yield this.config.getConfig();
            try {
                return yield this.httpClient.post(`${config['endpoint']}/Reembolso/ObtenerReembolsoFull`, iReembolso, { headers: this.headers }).toPromise();
            }
            catch (error) {
                return { status: false, code: 804, message: 'Error al ejecutar la petición.' };
            }
        });
    }
    // Solicitud Reembolso
    getEstadoSolicitudReembolsoWS() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            this.rut = localStorage.getItem('cbRutCliente');
            const config = yield this.config.getConfig();
            try {
                return yield this.httpClient.get(`${config['endpoint']}/SolicitudReembolso/EstadoWsSolReembolso?rut=${this.rut}`, { headers: this.headers }).toPromise();
            }
            catch (error) {
                return { status: false, code: 804, message: 'Error al ejecutar la petición.' };
            }
        });
    }
    getDatosContacto() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            this.rut = localStorage.getItem('cbRutCliente');
            const config = yield this.config.getConfig();
            try {
                return yield this.httpClient.get(`${config['endpoint']}/SolicitudReembolso/ObtenerDatosContacto?rut=${this.rut}`, { headers: this.headers }).toPromise();
            }
            catch (error) {
                return { status: false, code: 804, message: 'Error al ejecutar la petición.' };
            }
        });
    }
    getBancos() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const config = yield this.config.getConfig();
            try {
                return yield this.httpClient.get(`${config['endpoint']}/SolicitudReembolso/ObtenerListadoBancos`, { headers: this.headers }).toPromise();
            }
            catch (error) {
                return { status: false, code: 804, message: 'Error al ejecutar la petición.' };
            }
        });
    }
    getDatosBancarios() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            this.rut = localStorage.getItem('cbRutCliente');
            const config = yield this.config.getConfig();
            try {
                return yield this.httpClient.get(`${config['endpoint']}/SolicitudReembolso/ObtenerCtaBancariaCliente?rut=${this.rut}`, { headers: this.headers }).toPromise();
            }
            catch (error) {
                return { status: false, code: 804, message: 'Error al ejecutar la petición.' };
            }
        });
    }
    getDatosUbicacionSucursal() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            this.rut = localStorage.getItem('cbRutCliente');
            const config = yield this.config.getConfig();
            try {
                return yield this.httpClient.get(`${config['endpoint']}/SolicitudReembolso/ObtenerDatosUbicacionSucursal?rut=${this.rut}`, { headers: this.headers }).toPromise();
            }
            catch (error) {
                return { status: false, code: 804, message: 'Error al ejecutar la petición.' };
            }
        });
    }
    getComunasSucursales(codRegion) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const config = yield this.config.getConfig();
            try {
                return yield this.httpClient.get(`${config['endpoint']}/SolicitudReembolso/ObtenerComunasSucursales?codRegion=${codRegion}`, { headers: this.headers }).toPromise();
            }
            catch (error) {
                return { status: false, code: 804, message: 'Error al ejecutar la petición.' };
            }
        });
    }
    getSucursales(codComuna) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const config = yield this.config.getConfig();
            try {
                return yield this.httpClient.get(`${config['endpoint']}/SolicitudReembolso/ObtenerSucursales?codComuna=${codComuna}`, { headers: this.headers }).toPromise();
            }
            catch (error) {
                return { status: false, code: 804, message: 'Error al ejecutar la petición.' };
            }
        });
    }
    putCelular(iBeneficiario) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const config = yield this.config.getConfig();
            try {
                return yield this.httpClient.put(`${config['endpoint']}/SolicitudReembolso/ModificarCelular`, iBeneficiario, { headers: this.headers }).toPromise();
            }
            catch (error) {
                return { status: false, code: 804, message: 'Error al ejecutar la petición.' };
            }
        });
    }
    putEmail(iBeneficiario) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const config = yield this.config.getConfig();
            try {
                return yield this.httpClient.put(`${config['endpoint']}/SolicitudReembolso/ModificarEmail`, iBeneficiario, { headers: this.headers }).toPromise();
            }
            catch (error) {
                return { status: false, code: 804, message: 'Error al ejecutar la petición.' };
            }
        });
    }
    putCuentaBancaria(iBeneficiario) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const config = yield this.config.getConfig();
            try {
                return yield this.httpClient.put(`${config['endpoint']}/SolicitudReembolso/ModificarCuentaBancaria`, iBeneficiario, { headers: this.headers }).toPromise();
            }
            catch (error) {
                return { status: false, code: 804, message: 'Error al ejecutar la petición.' };
            }
        });
    }
}
ReembolsoService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function ReembolsoService_Factory() { return new ReembolsoService(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(i2.ConfigService)); }, token: ReembolsoService, providedIn: "root" });
